import { X, Clock, Zap } from "lucide-react";

// Section 6 — Out of Daily Credits modal. Shown when a FREE-tier user hits 0 on the
// 24-Hour Credit Balance while trying a credit-consuming action (Deep Scan). Offers
// Wait-for-reset (just close) or Upgrade (unlimited on PLUS/PRO/ELITE).
export default function OutOfCreditsModal({ open, onClose, resetAt, onUpgrade }) {
  if (!open) return null;
  const resetLabel = resetAt
    ? new Date(resetAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", timeZoneName: "short" })
    : "midnight UTC";

  return (
    <div id="out-of-credits-modal" data-testid="out-of-credits-modal" className="fixed inset-0 z-[170] flex items-center justify-center bg-black/70 p-4 backdrop-blur-md" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="max-h-[90vh] w-full max-w-sm overflow-y-auto rounded-3xl border border-slate-200 bg-white p-5 pb-[calc(1.25rem+env(safe-area-inset-bottom))] shadow-2xl dark:border-white/10 dark:bg-[#121214]">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-black text-slate-900 dark:text-white">Out of Daily Credits</h3>
          <button onClick={onClose} data-testid="out-of-credits-close" aria-label="Close">
            <X className="h-5 w-5 text-slate-400 hover:text-slate-700 dark:hover:text-white" />
          </button>
        </div>
        <p className="mt-2 text-sm text-slate-600 dark:text-zinc-300" data-testid="out-of-credits-message">
          You've used all your Deep Scan credits for today. Wait for your daily reset at {resetLabel}, or upgrade for unlimited Deep Scans.
        </p>
        <div className="mt-4 flex gap-2">
          <button onClick={onClose} data-testid="out-of-credits-wait" className="flex flex-1 items-center justify-center gap-1.5 rounded-xl border border-slate-300 py-2.5 text-xs font-black uppercase text-slate-600 dark:border-white/10 dark:text-zinc-300">
            <Clock className="h-3.5 w-3.5" /> Wait for Reset
          </button>
          <button onClick={onUpgrade} data-testid="out-of-credits-upgrade" className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-gradient-to-r from-brand-yellow to-brand-orange py-2.5 text-xs font-black uppercase text-slate-950">
            <Zap className="h-3.5 w-3.5" /> Upgrade
          </button>
        </div>
      </div>
    </div>
  );
}
